import React from 'react';
import PropTypes from 'prop-types';

import { formatCurrency } from 'utils/currency';
import styles from './SubscribeAndSaveLabel.module.scss';

const formatPrice = (price) => formatCurrency(Number(price));

const SubscribeAndSaveLabel = ({ isOneTimeView, salePrice, percentOff }) => {
  const label = isOneTimeView
    ? `${formatPrice(salePrice)} Subscribe & Save (${percentOff}% off)`
    : 'Subscribe & Save';
  return <p className={styles.subscriptionLabel}>{label}</p>;
};

SubscribeAndSaveLabel.propTypes = {
  isOneTimeView: PropTypes.bool.isRequired,
  salePrice: PropTypes.string.isRequired,
  percentOff: PropTypes.number.isRequired,
};

export default SubscribeAndSaveLabel;
